import { isScopeBasedConfig } from '../types/AccessCheckConfig';
export function enrichRequestAccessConfig(config) {
  const {
    requestAccessConfig
  } = config;
  if (isScopeBasedConfig(config) && config.requireAnyScope && requestAccessConfig) {
    return Object.assign({}, requestAccessConfig, {
      requireAnyScope: config.requireAnyScope
    });
  }
  return requestAccessConfig;
}